import React, { useState, useEffect } from "react";
import { Modal, Button, Typography } from "antd";
import { SESSION_STATUS, getSecondsLeft } from "./SessionTimeout";

const { Paragraph } = Typography;

const SessionExpirationModal = (props) => {
    const { t, status, deadline, inactiveMinutes, expiredReason, isContinuing, continueError, onContinue, onLoginAgain } = props;

    const isWarning = status === SESSION_STATUS.WARNING;
    const isExpired = status === SESSION_STATUS.EXPIRED;

    const [secondsLeft, setSecondsLeft] = useState(() => (deadline ? getSecondsLeft(deadline) : 0));

    // Countdown is recomputed from the deadline on every tick, so throttled timers in a
    // background tab skip ahead instead of pausing. Refresh immediately when the tab is shown.
    useEffect(() => {
        if (!isWarning || !deadline) return undefined;
        const refresh = () => setSecondsLeft(getSecondsLeft(deadline));
        refresh();
        const intervalId = setInterval(refresh, 1000);
        document.addEventListener("visibilitychange", refresh);
        return () => {
            clearInterval(intervalId);
            document.removeEventListener("visibilitychange", refresh);
        };
    }, [isWarning, deadline]);

    if (isExpired) {
        return (
            <Modal
                title={t("login.session.expired")}
                visible
                width={480}
                closable={false}
                maskClosable={false}
                keyboard={false}
                footer={[
                    <Button key="login" type="primary" onClick={onLoginAgain}>
                        {t("login.session.login_again")}
                    </Button>,
                ]}
            >
                {expiredReason === "server" ? t("login.session.server_expired_desc") : t("login.session.expired_desc")}
            </Modal>
        );
    }

    return (
        <Modal
            title={t("login.session.title")}
            visible={isWarning}
            width={480}
            closable={false}
            maskClosable={false}
            keyboard={false}
            footer={[
                <Button key="continue" type="primary" loading={isContinuing} onClick={onContinue}>
                    {t("login.continue")}
                </Button>,
            ]}
        >
            <Paragraph>{t("login.session.inactive", { minutes: inactiveMinutes })}</Paragraph>
            <Paragraph>
                {t("login.session.desc_1")} <strong>{secondsLeft}</strong> {t("login.session.desc_2")} {t("login.session.desc_3")}
            </Paragraph>
            {continueError ? <Paragraph type="danger">{t("login.session.verify_error")}</Paragraph> : null}
        </Modal>
    );
};

export default SessionExpirationModal;
